export default __webpack_public_path__ + "static/media/conversion-rate-optimazation.6275ba87.jpg";